import SidebarWindowWithTabs from 'components/ui/SidebarWindowWithTabs';

import { Settings } from './Settings';

const MapOperational = () => (
  <SidebarWindowWithTabs
    tabs={[<Settings key="settings" />]}
    tabOptions={['Настройки']}
    hideOptions
  />
);

export default MapOperational;
